























import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class ImplPreOperasiChecklist extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: Record<string, any>;
  @Prop({ default: false }) readonly disabled!: boolean;

  localValue: Record<string, any> = {};

  checkItems = [
    { key: "monitor_tanda_ansietas", label: "Monitor tanda-tanda ansietas" },
    { key: "jelaskan_prosedur_operasi", label: "Jelaskan prosedur operasi termasuk sensasi yang mungkin dialami" },
    { key: "identifikasi_nyeri", label: "Identifikasi lokasi, karakteristik, durasi, frekuensi, kualitas, intensitas nyeri" },
    { key: "kolaborasi_analgetik", label: "Kolaborasi pemberian analgetik bila perlu" },
    { key: "monitoring_vital_sign", label: "Monitoring vital sign" },
    { key: "atur_suhu_ruangan", label: "Mengatur suhu ruangan" },
    { key: "sign_in", label: "Melakukan Sign In" },
    { key: "monitor_intake_output", label: "Monitor intake output" },
    { key: "kolaborasi_cairan_preloading", label: "Kolaborasi pemberian cairan pre loading" },
    { key: "identifikasi_kesiapan_informasi", label: "Identifikasi kemampuan dan kesiapan menerima informasi" },
    { key: "pindah_brancart_meja_op", label: "Memindahkan pasien dari brancart ke meja operasi" },
    { key: "pencukuran", label: "Melakukan pencukuran" },
    { key: "atur_suhu_ruangan_18_20", label: "Mengatur suhu ruangan 18\u00b0C-20\u00b0C" }
  ];

  mounted() {
    this.localValue = { ...this.value };
  }

  @Watch("value", { deep: true })
  onValueChange(val) {
    this.localValue = { ...val };
  }

  emitChange() {
    this.$emit("input", { ...this.localValue });
  }
}
